// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1pfji","rootSmall":"AddTileButton_rootSmall__3rU_w"};